/** Error with a stable machine-readable code (same style as the server's `code: detail`). */
export class CoreError extends Error {
  readonly code: string

  constructor(code: string, message: string) {
    super(`${code}: ${message}`)
    this.name = 'CoreError'
    this.code = code
  }
}

export function assertSafeInt(value: number, name: string): void {
  if (!Number.isSafeInteger(value)) {
    throw new CoreError('invalid_input', `${name} must be a safe integer, got ${value}`)
  }
}
